export const GuidComponentIdToNonGuid: Record<string, string> = {
  'b5dfad3d-0bbb-4e8a-8630-c70e0abc4ae4': 'restaurants-menus-management-items',
  'e7b7afbb-6d4e-46b2-8bd6-0af78dc9d21e': 'membership-lazy-component',
  'c821a776-85a9-4340-ae94-e08876c99944':
    'wixstores-dashboard-product-list.pages.index',
  '79dbb935-d823-4feb-9272-ef2cbcf2aafd': 'subscriptions-bm',
  '4309112c-adcb-4a9d-8027-454b107afe76':
    'cairo-example-bm.pages.infinite-scroll-table-v2',
};

export function mapGuidComponentIdToNonGuid(componentId: string): string {
  if (GuidComponentIdToNonGuid[componentId]) {
    return GuidComponentIdToNonGuid[componentId];
  }
  return componentId;
}
